import {
    ArrowRightIcon,
    Button,
    CloseIcon,
    Dropdown,
    Flex,
    TextArea,
} from "@fluentui/react-northstar";
import { CustomBadge } from "../../../../components/Badge";
import { DialogStyle } from "../absences/AbsenceRequest";
import useLogicCompensateSolde from "../../hooks/useLogicCompensateSolde";
import { DEFAULT_HOURS_VALUE } from "../../constants";
import {
    Grid,
    RoundedArrow,
    SInput,
    SInputLabel,
    TextHours,
    TextHoursCenter,
    TextLabel,
    WrapperCards,
} from "./style";
import { ErrorMessage } from "../../../../common/styles";

const DialogCompensateSolde = ({ open: openDefault, setOpen }) => {
    const { dialog, queries, view, event_handlers } = useLogicCompensateSolde({
        openDefault,
        setOpen,
    });

    return (
        <DialogStyle
            open={dialog.open}
            header="Compenser les heures supplémentaires"
            content={
                <Flex column gap="gap.large" styles={{ marginTop: "10px" }}>
                    {/* personne concernée */}
                    <Flex column>
                        <SInputLabel content="Personne concernée" />
                        <Dropdown
                            search
                            items={queries.employees.data}
                            value={view.personConcerned}
                            placeholder=""
                            noResultsMessage="We couldn't find any matches."
                            a11ySelectedItemsMessage="Press Delete or Backspace to remove"
                            fluid
                            onChange={(_, i) => {
                                return event_handlers.onChangePersonConcerned(
                                    i?.value || null
                                );
                            }}
                        />
                    </Flex>
                    {/* Solde à ajuster */}
                    <Flex column>
                        <SInputLabel content="Solde à ajuster" />
                        <Dropdown
                            items={queries.balance_to_adjusted.data}
                            noResultsMessage="We couldn't find any matches."
                            a11ySelectedItemsMessage="Press Delete or Backspace to remove"
                            fluid
                            value={view.soldeToAdjust}
                            disabled={view.disabled_input_adjut_solde}
                            checkable
                            onChange={(_, i) => {
                                return event_handlers.onChangeSoldeToAdjust(
                                    i?.value || null
                                );
                            }}
                        />
                    </Flex>
                    {/* Montant de l'ajustement */}
                    <Flex styles={{ gap: "80px" }}>
                        {/* left */}
                        <Flex column>
                            <SInputLabel content="Montant de l'ajustement" />
                            <div>
                                <SInput
                                    icon={"jour(s)"}
                                    type="number"
                                    min="0"
                                    max="365"
                                    placeholder="-,---"
                                    value={view.days}
                                    onChange={event_handlers.onChangeDays}
                                />
                            </div>
                            {view.days_error && (
                                <ErrorMessage content={view.days_error} />
                            )}
                            <CustomBadge
                                bg="#FBF6D9"
                                rectangular={true}
                                color="black"
                                label={`1 j = ${
                                    queries.hours_soldes.data
                                        ?.user_hours_count_per_day ??
                                    DEFAULT_HOURS_VALUE
                                } h`}
                                styles={{
                                    borderRadius: "4px",
                                }}
                            />
                        </Flex>
                        {/* right - calculation */}
                        <WrapperCards>
                            <Grid>
                                {/* first row */}
                                <Flex>
                                    <TextLabel content="avant" />
                                </Flex>
                                <Flex styles={{ paddingTop: "8px" }}>
                                    <RoundedArrow
                                        hAlign="center"
                                        vAlign="center"
                                    >
                                        <ArrowRightIcon size="small" />
                                    </RoundedArrow>
                                </Flex>
                                <Flex>
                                    <TextLabel $primary content="Après" />
                                </Flex>
                                {/* second row */}
                                <Flex>
                                    <TextHours
                                        content={`${
                                            queries.hours_soldes.data?.value ??
                                            DEFAULT_HOURS_VALUE
                                        } h`}
                                    />
                                </Flex>
                                <Flex>
                                    <TextHoursCenter
                                        content={`${
                                            view.calculate_hours
                                                ?.daysInHours !==
                                            DEFAULT_HOURS_VALUE
                                                ? "- " +
                                                  view.calculate_hours
                                                      ?.daysInHours
                                                : DEFAULT_HOURS_VALUE
                                        } h`}
                                    />
                                </Flex>
                                <Flex>
                                    <TextHours
                                        $primary
                                        content={`${view.calculate_hours?.resultHours} h`}
                                    />
                                </Flex>
                            </Grid>
                        </WrapperCards>
                    </Flex>
                    {/* Raison (facultatif) */}
                    <Flex column>
                        <SInputLabel content="Raison (facultatif)" />
                        <TextArea
                            placeholder="Ajoutez un commentaire"
                            fluid
                            value={view.reason}
                            onChange={(_, data) => {
                                return event_handlers.onChangeReason(
                                    data?.value || ""
                                );
                            }}
                        />
                    </Flex>
                </Flex>
            }
            confirmButton={{
                content: "Valider la compensation",
                loading: view.is_submiting_form,
                flat: true,
                primary: true,
                disabled: view.disabled_button_confirm,
                onClick: () => event_handlers.onSubmitForm(),
            }}
            headerAction={{
                icon: <CloseIcon />,
                onClick: dialog.close,
            }}
            onCancel={dialog.close}
            footer={{
                children: (Component, props) => {
                    const { styles, ...rest } = props;
                    return (
                        <Flex styles={styles} fill hAlign="end">
                            <Button
                                content="Annuler"
                                disabled={view.disabled_button_reset}
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    return event_handlers.onResetForm();
                                }}
                                flat
                                text
                                styles={{
                                    textDecoration: "underline",
                                    color: view.disabled_button_reset
                                        ? "#C7C7C7"
                                        : "var(--color-danger)",
                                }}
                            />
                            <Component {...rest} />
                        </Flex>
                    );
                },
            }}
        />
    );
};

export default DialogCompensateSolde;
